import {
    CAMPAIGNS_REQUESTED,
    CAMPAIGNS_SUCCEEDED,
    CAMPAIGNS_FAILED,
} from './constants';

const initialState = {
    // initial state of campaigns
    campaigns: [],
    // initial state of campaigns loading state
    campaignsLoading: false,
    error: '',
};

export default function(state = initialState, action) {
    switch (action.type) {
        case CAMPAIGNS_REQUESTED: {
            const { campaignsLoading } = action;
            return {
                ...state,
                campaignsLoading,
            };
        }
        case CAMPAIGNS_SUCCEEDED: {
            const { campaigns } = action;
            const { campaignsLoading } = action;
            return {
                ...state,
                campaigns,
                campaignsLoading,
            };
        }
        case CAMPAIGNS_FAILED: {
            const { error } = action;
            const { campaignsLoading } = action;
            return {
                ...state,
                error,
                campaignsLoading,
            };
        }
        default:
            return state;
    }
}
